import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@app/base/basecomponent';
import { Router } from '@angular/router';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { SettingService } from '@app/areas/setting/setting.service';

@Component({
  selector: 'assingment-quick-link',
  templateUrl: './assingment-quick-link.component.html',
  styleUrls: ['./assingment-quick-link.component.scss']
})
export class AssingmentQuickLinkComponent extends BaseComponent implements OnInit {

  public form: UntypedFormGroup;
  public open: boolean = false; // added extra ngIf for dropdown in order to get afterViewInit lifecycle firing for kupari-input
  public assignmentPrefix: string = "";
  @ViewChild('dropdown') dropdown: BsDropdownDirective;

  constructor(
    private router: Router,
    private settingService: SettingService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.assignmentPrefix = this.settingService.getSetting("assignmentPrefix") || "";

    this.form = this.formBuilder.group({
      id: [null, [Validators.required, Validators.pattern(/^-?(0|[1-9]\d*)?$/)]]
    });
  }


  onSubmit() {
    this.formError(this.form);
    if (!this.form.valid) {
      return;
    }

    this.router.navigate(['/assignment', Number(this.form.get('id').value)]);
    this.form.get('id').reset();
    setTimeout(() => {
      this.dropdown.hide();
    }, 400);
  }

  onOpen() {
    this.form.get('id').reset();
    this.open = true;
  }

  onHide() {
    this.open = false;
  }

}
